import axios from "../utils/AxiosInstance";
import { ResponseMessage } from "../models/ResponseMessage";
import { Constants } from "../constants/constants";
import { ContactInquiry } from "../models/InquiryModels";

const API_BASE_URL = Constants.API_BASE_URL;

export async function getInquiriesByOrganizationAsync(
  token: string,
  organizationId: string,
  status?: number,
): Promise<ResponseMessage<ContactInquiry[]>> {
  const response = await axios.get(
    `${API_BASE_URL}/contactinquiries/organization/${organizationId}`,
    {
      params: status === undefined ? undefined : { status },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function getNewInquiryCountAsync(
  token: string,
  organizationId: string,
): Promise<ResponseMessage<number>> {
  const response = await axios.get(
    `${API_BASE_URL}/contactinquiries/organization/${organizationId}/new-count`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function updateInquiryStatusAsync(
  token: string,
  id: string,
  status: number,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.put(
    `${API_BASE_URL}/contactinquiries/${id}/status`,
    { status },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  return ResponseMessage.fromJson(response.data);
}

export async function deleteInquiryAsync(
  token: string,
  id: string,
): Promise<ResponseMessage<boolean>> {
  const response = await axios.delete(`${API_BASE_URL}/contactinquiries/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return ResponseMessage.fromJson(response.data);
}
